/**
 * Link
 */
export const GOOGLE_CALENDAR_LINK = `https://calendar.google.com/calendar/event?action=TEMPLATE&dates=20201003T040000Z%2F20201003T060000Z&text=Dinda+%26+Indra+Wedding&details=Dinda+%26+Indra+Wedding`;
export const GOOGLE_MAPS_LINK = `https://g.page/HARRISHotelSentralandSemarang?share`;

/**
 * Wedding time
 */
export const EPOCH_START_EVENT = 1769193600; // 07:00 24/01/2026 (VN)
export const EPOCH_END_EVENT = 1769316000; // 17:00 25/01/2026 (VN)
export const UTC_WEDDING_TIME = '2026-01-24T00:00:00Z';
